import { ExchangeSelector, useStoreExchange } from "@usher/pe-client-front-end-lib"
import { Selector } from "../Selector"

export const ExchangeBoxItem = ({ selector }: { selector: ExchangeSelector }) => {
  const { amount, currency, setAmount, setCurrency, currencies } = useStoreExchange(selector)
  const options = currencies.map((item) => ({ value: item, label: item }))

  return (
    <div className="markets-actions__form-input box-light">
      <input type="text" value={amount} onChange={(e) => setAmount(e.target.value)} className="markets-actions__field" />
      <div className="markets-actions__select">
        <Selector
          classNames={{ control: "pr-0" }}
          options={options}
          value={{ value: currency, label: currency }}
          onChange={(option) => setCurrency(option?.value ?? "")}
        />
      </div>
    </div>
  )
}
